// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// NGRX
import { Store } from '@ngrx/store';
// RxJS
import { Subject, Subscription } from 'rxjs';

import { SubheaderService } from '../../../../core/_base/layout';
// AppState
import { AppState } from '../../../../core/reducers';

@Component({
  selector: 'kt-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss'],
})
export class GeneralSettingsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  saveSubject: Subject<void> = new Subject<void>();

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private subheaderService: SubheaderService
  ) {}

  ngOnInit() {
    this.subheaderService.setTitle('Γενικές Ρυθμίσεις');
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
}
